export const ImageSize = {
    small: 'min-w-[4rem] lg:min-w-[5rem] xl:min-w-[6rem] max-w-[4rem] lg:max-w-[5rem] xl:max-w-[6rem] h-16 lg:h-20 xl:h-24 object-cover',
    medium: 'w-20 h-20 object-cover',
    large: 'w-32 lg:w-36 xl:w-40 h-32 lg:h-36 xl:h-40 object-cover',
    xlarge: 'w-32 lg:w-40 xl:w-48 h-32 lg:h-40 xl:h-48 object-cover',
}
